import { Component, OnInit, HostBinding } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { ShareService } from '../../services/share.service';
import { Utils } from '../../utils';

export class SimpleNotificationParams
{
  constructor(public title: string = 'Notification', public text: string = '', public error: boolean = false)
  {  
  }
}

@Component({
  selector: '[simple-notification]',
  template: require('./simple-notification.component.html'),
  styles: [require('./simple-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])],
  preserveWhitespaces: false,
})
export class SimpleNotificationComponent extends Toast implements OnInit {
  params: SimpleNotificationParams;

  @HostBinding('class.error')
  get error()
  {
      return this.params.error;
  }
  
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) 
  {
    super(toastrService, toastPackage);
    this.params = JSON.parse(Utils.decodeHTMLEntities(this.message as string));
  }

  ngOnInit() {
  }

}
